import { defineStore } from "pinia";
import { ref } from "vue";
import { client } from "@/main";
export const useGatewaysStore = defineStore("gateways", () => {
    const detail = ref({});
    const isLoading = ref(false);
    async function getGateway(gatewayId, isFullDetail = false) {
        isLoading.value = true;
        const { data } = await client.path("/mqtt/gateways/{id}").method("get").create()({
            id: String(gatewayId),
            fullDetail: isFullDetail || undefined
        });
        detail.value = data.data?.[0] ?? {};
        isLoading.value = false;
    }
    async function deleteGateway(id) {
        await client.path("/mqtt/gateways/{id}").method("delete").create()({
            id: String(id ?? detail.value.custDestId)
        });
    }
    return { detail, isLoading, getGateway, deleteGateway };
});
